/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.SelfCheckInKiosk {


    import Timer = NodeJS.Timer;

    class CheckInSuccessController {
        public static $inject = [
            '$state',
            'meevo.plugins.selfCheckInKiosk.SelfCheckInKioskLogic',
            'meevo.AppSettings',
            'meevo.components.modal.ModalService',
            '$scope',
            'meevo.components.busy.BusyService'
        ];

        checkinResultMessage: string;
        seconds: number;
        resetTimer: Timer;

        constructor(protected $state: ng.ui.IStateService,
                    protected selfCheckInKioskLogic: SelfCheckInKioskLogic,
                    protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    protected $scope: ng.IScope,
                    protected busyService: Meevo.Components.Busy.IBusyService) {
            this.seconds = this.selfCheckInKioskLogic.kioskSettings.messageTimeout;

            this.busyService.start();

            this.selfCheckInKioskLogic
                .checkinData()
                .then(() => {
                    this.checkinResultMessage = this.selfCheckInKioskLogic.kioskSettings.successfulCheckinMessage;
                })
                .catch(() => {
                    this.checkinResultMessage = this.selfCheckInKioskLogic.kioskSettings.unsuccessfulCheckinMessage;
                })
                .finally(() => {
                    if (!this.checkinResultMessage) this.checkinResultMessage = this.selfCheckInKioskLogic.kioskSettings.unsuccessfulCheckinMessage;
                    this.busyService.stop();

                    this.resetTimer = setInterval(() => {

                        this.$scope.$apply(() => {
                            this.seconds--;

                            if (this.seconds <= 0) {

                                this.reset();
                                clearInterval(this.resetTimer);
                            }
                        });
                    }, 1000);
                });
        }

        reset() {
            this.$state.go(`${this.appSettings.ROUTE_NAMES.selfCheckInKiosk}.login`);
            this.selfCheckInKioskLogic.reset();
        }
    }


    angular.module('meevo.plugins.selfCheckInKiosk')
        .controller('meevo.plugins.selfCheckInKiosk.CheckInSuccessController', CheckInSuccessController);
}
